import "./../../base";
import { handleFormSecurity } from "../../security";
import isDomainNameUsed from "../../helpers/zoneChecker";
import { pushToGa4 } from "../../helpers/pushToDataLayer";
import serialize from "form-serialize";
import formResponseHandler from "../../helpers/form-response-handler";

const newAccountButton = document.querySelector("#x-new-account");
const existAccountLink = document.querySelector("#x-exits-account");
const forgotDomainLink = document.querySelector("#x-forgot-domain");

handleFormSecurity("zone_registration[_token]", "zone_registration");

let form = document.querySelector('form[name="zone_registration"]');
let zoneInput = document.querySelector('input[name="zone_registration[slug]"]');

["keyup", "change"].forEach((event) => form.addEventListener(event, () => {
    setFormError("");
    enableButtons();
}));

form.addEventListener("submit", async (event) => {
    event.preventDefault();

    if (newAccountButton.classList.contains('c-button--disabled')) {
        return;
    }

    formValidate();

    if (!zoneInput.checkValidity()) {
        return;
    }

    let domainExist = await isDomainNameUsed(zoneInput.value, (error) => {
        setFormError(error);
    });

    if (domainExist) {
        pushToGa4(
            "send_create_new_account_error",
            "advertiser integrations",
            "shopify",
            "undefined",
        );

        setFormError(
            "This subdomain is already in use. Please choose another subdomain name, or log in (below) if you’re the owner.",
        );

        return;
    }

    setLoadingState(newAccountButton, true);

    return fetch(window.location.href, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: serialize(form),
        credentials: "include",
    })
        .then((result) => {

            if (result.status !== 200 || result.headers.has("X-Form-Errors")) {
                pushToGa4(
                    "send_create_new_account_error",
                    "advertiser integrations",
                    "shopify",
                    "undefined",
                );
            } else {
                pushToGa4(
                    "send_create_new_account_success",
                    "advertiser integrations",
                    "shopify",
                    "undefined",
                );
            }

            return result;

        })
        .then(formResponseHandler)
        .then((result) => {
            if (result === false) {
                handleFormSecurity().then(() => setLoadingState(newAccountButton, false));
                enableButtons();
            }
        });
});

existAccountLink.addEventListener("click", async (event) => {
    event.preventDefault();

    if (event.target.classList.contains('c-button--disabled')) {
        return;
    }

    formValidate();

    if (!zoneInput.checkValidity()) {
        return;
    }

    let domainExist = await isDomainNameUsed(zoneInput.value, (error) => {
        setFormError(error);

        pushToGa4(
            "send_log_in_existing_account_error",
            "advertiser integrations",
            "shopify",
            "undefined",
        );
    }, true);

    if (true === domainExist) {
        const pathname = window.location.pathname.replace("/register/", "/register/exist/");

        setLoadingState(existAccountLink, true);
        let search = window.location.search || "?";
        search += `&zone=${zoneInput.value}`;

        pushToGa4(
            "send_log_in_existing_account_success",
            "advertiser integrations",
            "shopify",
            "undefined",
        );

        window.location.href = `${pathname}${search}`;
    } else if (false === domainExist) {
        setFormError(
            "This subdomain doesn’t exist. Please try another subdomain, or use the button above to create a new account with this subdomain",
        );

        pushToGa4(
            "send_log_in_existing_account_error",
            "advertiser integrations",
            "shopify",
            "undefined",
        );
    }

    enableButtons();
});

function formValidate() {
    let isValid = zoneInput.checkValidity();

    disableButtons();

    if (!isValid) {
        let validity = zoneInput.validity;

        switch (true) {
            case validity.badInput:
                setFormError('You can only use: a-z A-Z 0-9. Hyphens (\"-\") can be used if surrounded by other characters, for example \"My-Business\".')
                break;
            case validity.patternMismatch:
                setFormError('Only (lowercase) letters and numbers (a-z & 0-9) are allowed.')
                break;
            case validity.tooShort:
                setFormError('Subdomain must be at least 3 characters long.')
                break;
            case validity.valueMissing:
                setFormError('This value should not be blank.')
                break;
            default:
                setFormError('')
        }
    }
}

function setLoadingState(element, loading) {
    if (loading) {
        element.classList.add("c-button--loading");
        element.setAttribute("disabled", "");
    } else {
        element.classList.remove("c-button--loading");
        element.removeAttribute("disabled");
    }
}

function setFormError(message) {
    let globalErrors = document.getElementsByClassName("c-form__global-errors")[0];
    globalErrors.innerHTML = "";
    globalErrors.insertAdjacentHTML("afterbegin", `<div class="c-input__error">${message}</div>`);
}

const disableButtons = function () {
    newAccountButton.classList.add("c-button--disabled");
    newAccountButton.disabled = true;
    existAccountLink.classList.add("c-button--disabled");
    existAccountLink.disabled = true;
}

const enableButtons = function() {
    newAccountButton.classList.remove("c-button--disabled");
    newAccountButton.disabled = false;
    existAccountLink.classList.remove("c-button--disabled");
    newAccountButton.disabled = false;
}
